import { faSearch } from '@fortawesome/free-solid-svg-icons'
import Button from 'components/Button'
import Input from 'components/SearchInput'
import { InputField } from 'components/InputField'
import { Form, Formik, FormikProps } from 'formik'

type FormValues = {
  voucherCode: string
  voucherName: string
  startDate: string
}

type Props = {
  startFetching: (values: FormValues) => void
  startLoading: () => void
  closeSearchForm: () => void
}

const initialValues: FormValues = {
  voucherCode: '',
  voucherName: '',
  startDate: '',
}

const VoucherSearchForm = ({
  startFetching,
  startLoading,
  closeSearchForm,
}: Props): JSX.Element => (
  <div className="box-border absolute flex w-3/4 p-4 my-1 text-base bg-white border border-gray-500 pr-96 top-12 z-50">
    <Formik
      initialValues={initialValues}
      validationSchema={false}
      onSubmit={async (values, { setStatus }) => {
        try {
          startLoading()
          closeSearchForm()
          // set fetching to true
          startFetching({
            ...values,
            // startDate: values.startDate
            //   ? `${values.startDate}T00:00:00`
            //   : '',
          })
        } catch (error) {
          if (error instanceof Error) {
            setStatus(error.message)
          }
        }
      }}
    >
      {({ status, isValid }: FormikProps<FormValues>) => (
        <Form className="w-full mb-4" autoComplete="off">
          <Input
            name="voucherCode"
            type="text"
            label="Voucher Code"
          />
          <Input
            name="voucherName"
            type="text"
            label="Voucher Name/PLU"
            labelClassName="text-gray-500"
          />
          <Input
            name="startDate"
            type="date"
            label="Start Date"
            labelClassName="text-gray-500"
          />
          <Input
            name="productSKU"
            type="text"
            label="Product SKU"
            labelClassName="text-gray-500"
          />
          <Button
            type="submit"
            className="flex px-12 mt-5 text-sm"
            iconClassName="mt-0.5"
            icon={faSearch}
            disabled={!isValid}
            rounded
          >
            <span className="tracking-wider font-bold">Search</span>
          </Button>
          <p>
            <span className="tracking-wider font-light">{status}</span>
          </p>
        </Form>
      )}
    </Formik>
  </div>
)

export default VoucherSearchForm
